import axios from 'axios';
import * as types from '../constants/ActionTypes';

function receiveChatEligibilityError() {
  return {
    type: types.RECEIVE_CHAT_ERROR,
    payload: undefined,
  };
}

function receiveChatEligibilityResponse(responseData) {
  return {
    type: types.RECEIVE_CHAT_RESPONSE,
    payload: {
      isChatEnabled: responseData.chatEnabled,
      waitTime: responseData.ewt,
    },
  };
}

function fetchChatEligibility(topicId) {
  return dispatch => axios.get(`/smarthelp/node-chat/chat/eligibility?topicName=${topicId}`)
      .then(response => dispatch(receiveChatEligibilityResponse(response.data)))
      .catch(() => dispatch(receiveChatEligibilityError()));
}

export default fetchChatEligibility;
